module.exports = __webpack_public_path__ + "static/media/2_en.92e7ae91.png";